import { format } from "date-fns";
import { FaUserDoctor, FaUserNurse, FaUserTie } from "react-icons/fa6";
import { motion } from "framer-motion";
import { Button } from "primereact/button";
import { useState } from "react";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";

const shadowTailWind = "shadow-[0px_0px_4px_0px_#00000024]";

const AdminListAppointmentItem = (props) => {
  const { event, backgroundColor, textColor, onClick } = props;
  const data = event.data;

  const isPast = event.date < new Date().setHours(0, 0, 0, 0);
  const animate = !event.data.confirmation_bc_date ? true : false;
  const stale = !event.data.confirmation_bc_date ? true : false;

  const [visibleWhatsappDialog, setVisibleWhatsappDialog] = useState(false);
  const [selectedCustomerPhone, setSelectedCustomerPhone] = useState(null);
  const [noteWhatsapp, setNoteWhatsapp] = useState("");

  const handleWhatsappNotify = () => {
    const phone = selectedCustomerPhone;
    if (!phone) return;

    const encodedMessage = encodeURIComponent(noteWhatsapp);
    window.open(`https://wa.me/${phone}?text=${encodedMessage}`, "_blank");

    setVisibleWhatsappDialog(false);

    // still call parent if needed
    if (onClick) onClick(event);
  };

  return (
    <motion.div
      className={`row-start-start ${isPast ? " bg-slate-100 " : shadowTailWind
        } ${stale ? " !bg-slate-50 " : ""
        } w-full gap-2 cursor-pointer active:translate-y-0.5 active:bg-slate-50 !items-stretch `}
      animate={
        animate
          ? {
            rotate: [0, -2, 2, 0],
            translateY: [0, -2, 0, 0],
          }
          : undefined
      }
      transition={
        animate
          ? {
            duration: 1,
            ease: "easeInOut",
            times: [0, 0.33, 0.677, 1],
            repeat: Infinity,
            repeatDelay: 0,
          }
          : undefined
      }
      onClick={() => {
        if (onClick) onClick(event);
      }}
    >
      <div
        className={` w-[3px] ${isPast || stale ? "bg-slate-300" : backgroundColor
          }`}
      />
      <div className={`col-center-start pt-1 w-full`}>
        <div className={`col-start-start w-full`}>
          <div className="row-between-center w-full">
            <span
              className={`text-sm ${isPast || stale ? "text-slate-400" : textColor
                } font-semibold`}
            >
              {data && data.data_customer
                ? `${data.data_customer ? data.data_customer.name : "-"} ( ${data.data_customer ? data.data_customer.code : "-"
                } )`
                : event.title}
            </span>
            <Button
              icon="pi pi-whatsapp"
              rounded
              severity="success"
              text
              className="!w-8 !h-8"
              aria-label="Send WhatsApp"
              onClick={(e) => {
                e.stopPropagation();
                const phone = event.data?.data_customer?.phone_1 || event.data?.data_customer?.phone_2;
                setSelectedCustomerPhone(phone);

                //Template greeting message
                const hour = new Date().getHours();
                let greeting = "Selamat pagi";
                if (hour >= 11 && hour < 15) greeting = "Selamat siang";
                if (hour >= 15 && hour < 18) greeting = "Selamat sore";
                if (hour >= 18 || hour < 5) greeting = "Selamat malam";

                const customerName = event.data?.data_customer?.name || "CustomerName";

                // Today's date in yyyy-MM-dd for comparison
                const today = format(new Date(), "yyyy-MM-dd");

                // Appointment day
                const appointmentDay = format(new Date(event.date), "yyyy-MM-dd");

                // Check if appointment is today
                const isToday = appointmentDay === today;

                // Transaction date (source date) in Indonesian format
                const transactionDateID = event.data?.transaction_date
                  ? format(new Date(event.data.transaction_date), "dd/MM/yyyy")
                  : "-";

                // Appointment time
                const appointmentTime = format(new Date(event.date), "HH:mm");

                // Construct message
                const message =
                  `${greeting} ${customerName},\r\n\r\n` +
                  `Reminder appointment Anda ${isToday ? "hari ini" : "pada tanggal " + transactionDateID}.\r\n` +
                  `Jam: ${appointmentTime} WIB\r\n\r\n` +
                  `Mohon reply dengan pilihan berikut:\r\n` +
                  `1. Hadir\r\n` +
                  `2. Reschedule\r\n` +
                  `3. Tanya detail\r\n\r\n` +
                  `Terima kasih banyak!`;

                // Set message to state
                setNoteWhatsapp(message);

                setVisibleWhatsappDialog(true);
              }}
            />
          </div>
          <span className="text-sm text-slate-400">
            {format(new Date(event.date), "hh:mm aa")}
            {data.edit_by ? `, by ${data.edit_by}` : ""}
          </span>
          {/* BC */}
          {data && data.data_bc && (
            <div className="row-start-center">
              <div className="w-[1.3rem]">
                <FaUserTie className="text-slate-400 text-sm" />
              </div>
              <span className="text-sm text-slate-400">
                {data.data_bc ? data.data_bc.name : "-"}
              </span>
            </div>
          )}
        </div>

        {data && (
          <div className="col-start-start pb-2 pt-3 gap-4 w-full">
            {data.description && (
              <span className="text-sm text-slate-500">{data.description}</span>
            )}
            {/* crm options */}
            {data.data_crm_options && data.data_crm_options.length > 0 && (
              <div className="col-start-start w-full gap-1">
                <div className="row-start-center gap-1 w-full pr-1">
                  <div className="bg-slate-300 w-[0.5rem] h-[2px]" />
                  <span className="text-sm font-semibold text-slate-400">
                    {" "}
                    Customer Request{" "}
                  </span>
                  <div className="grow-1 bg-slate-300 h-[2px]" />
                </div>
                <div className="col-start-start gap-1 pl-2">
                  {data.data_crm_options.map((option, index) => (
                    <div key={index} className="row-start-center gap-2 w-full">
                      <i className="pi pi-circle-fill text-[0.3rem] text-slate-500" />
                      <span className="text-sm text-slate-500">
                        {option.name}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {/* bc recommendation */}
            {data.data_products && data.data_products.length > 0 && (
              <div className="col-start-start w-full gap-1">
                <div className="row-start-center gap-1 w-full pr-1">
                  <div className="bg-slate-300 w-[0.5rem] h-[2px]" />
                  <span className="text-sm font-semibold text-slate-400">
                    BC Recommendation
                  </span>
                  <div className="grow-1 bg-slate-300 h-[2px]" />
                </div>
                <div className="col-start-start gap-1 pl-2">
                  {data.data_products.map((option, index) => (
                    <div key={index} className="row-start-center gap-2 w-full">
                      <i className="pi pi-circle-fill text-[0.3rem] text-slate-500" />
                      <span className="text-sm text-slate-500">
                        {option.data_product.name}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {/* treatment by */}
            <div className="col-start-start w-full gap-1">
              <div className="row-start-center gap-1 w-full pr-1">
                <div className="bg-slate-300 w-[0.5rem] h-[2px]" />
                <span className="text-sm font-semibold text-slate-400">
                  Treatment By
                </span>
                <div className="grow-1 bg-slate-300 h-[2px]" />
              </div>
              <div className="col-start-start gap-1 pl-1">
                {/* doctor */}
                {data.data_doctor && (
                  <div className="row-start-center">
                    <div className="w-[1.3rem]">
                      <FaUserDoctor className="text-slate-500 text-sm" />
                    </div>
                    <span className="text-sm text-slate-500">
                      {data.data_doctor ? data.data_doctor.name : "-"}
                    </span>
                  </div>
                )}
                {/* nurse */}
                {(data.data_nurse_1 ||
                  data.data_nurse_2 ||
                  data.data_nurse_3) && (
                    <div className="row-start-center">
                      <div className="w-[1.3rem]">
                        <FaUserNurse className="text-slate-500 text-sm" />
                      </div>
                      <div className="row-start-center gap-2">
                        {data.data_nurse_1 && (
                          <span className="text-sm text-slate-500">
                            {data.data_nurse_1.name}
                          </span>
                        )}
                        {data.data_nurse_2 && (
                          <span className="text-sm text-slate-500">
                            {data.data_nurse_2.name}
                          </span>
                        )}
                        {data.data_nurse_3 && (
                          <span className="text-sm text-slate-500">
                            {data.data_nurse_3.name}
                          </span>
                        )}
                      </div>
                    </div>
                  )}
                {/* therapist */}
                {(data.data_therapist_1 ||
                  data.data_therapist_2 ||
                  data.data_therapist_3) && (
                    <div className="row-start-center">
                      <div className="w-[1.3rem]">
                        <FaUserDoctor className="text-slate-500 text-sm" />
                      </div>
                      <div className="row-start-center gap-2">
                        {data.data_therapist_1 && (
                          <span className="text-sm text-slate-500">
                            {data.data_therapist_1.name}
                          </span>
                        )}
                        {data.data_therapist_2 && (
                          <span className="text-sm text-slate-500">
                            {data.data_therapist_2.name}
                          </span>
                        )}
                        {data.data_therapist_3 && (
                          <span className="text-sm text-slate-500">
                            {data.data_therapist_3.name}
                          </span>
                        )}
                      </div>
                    </div>
                  )}
              </div>
            </div>
            {/* doctor note */}
            {data.doctor_note && data.doctor_note.length > 0 && (
              <div className="col-start-start w-full gap-1">
                <div className="row-start-center gap-1 w-full pr-1">
                  <div className="bg-slate-300 w-[0.5rem] h-[2px]" />
                  <span className="text-sm font-semibold text-slate-400">
                    Doctor's Note
                  </span>
                  <div className="grow-1 bg-slate-300 h-[2px]" />
                </div>
                <div className="col-start-start gap-1 pl-1">
                  <span className="text-sm text-slate-500">
                    {data.doctor_note ? data.doctor_note : "-"}
                  </span>
                </div>
              </div>
            )}
            {data?.notification_note && (
              <div className="col-start-start w-full gap-1">
                <div className="row-start-center gap-1 w-full pr-1">
                  <div className="bg-slate-300 w-[0.5rem] h-[2px]" />
                  <span className="text-sm font-semibold text-slate-400">
                    Notification Note
                  </span>
                  <div className="grow-1 bg-slate-300 h-[2px]" />
                </div>
                <span className="text-sm font-semibold text-slate-400">
                  {data.notification_note ? data.notification_note : "-"}
                </span>
              </div>
            )}
          </div>
        )}
        <Dialog
          header="Send WhatsApp Note"
          visible={visibleWhatsappDialog}
          style={{ width: "50rem" }}
          onHide={(e) => {
            e.stopPropagation();
            setVisibleWhatsappDialog(false);
          }}
          pt={{
            mask: {
              onClick: (e) => e.stopPropagation(), // ✅ Prevents backdrop from bubbling to parent
            }
          }}
          footer={
            <div className="flex justify-end gap-2">
              <Button
                label="Cancel"
                text
                onClick={(e) => {
                  e.stopPropagation();
                  setVisibleWhatsappDialog(false);
                }}
              />
              <Button
                label="Send WhatsApp"
                onClick={(e) => {
                  e.stopPropagation();
                  handleWhatsappNotify();
                }}
                disabled={!selectedCustomerPhone}
                autoFocus
              />
            </div>
          }
          onClick={(e) => e.stopPropagation()} // ✅ Prevents clicks inside dialog from bubbling
        >
          <div className="col-start-start gap-2 w-full">
            <InputTextarea
              value={noteWhatsapp}
              onChange={(e) => setNoteWhatsapp(e.target.value)}
              rows={10}
              className="w-full"
              placeholder="Write notification note..."
              onClick={(e) => e.stopPropagation()} // ✅ Textarea safe
            />

            <span className="text-sm text-slate-400">
              Will send to: <strong>{selectedCustomerPhone || "-"}</strong>
            </span>
          </div>
        </Dialog>
      </div>
    </motion.div>
  );
};

export default AdminListAppointmentItem;
